import { render, staticRenderFns } from "./ViewerContentForm.vue?vue&type=template&id=512c15fa&"
import script from "./ViewerContentForm.vue?vue&type=script&lang=ts&"
export * from "./ViewerContentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports